import axios from "axios";
import { addClass, escapeTag, hasClass, removeClass, toggle } from "../common/Utils";

interface Ioption {
    apiUrl: string;
    selector : string;
    size: number;
    useDelbtn: boolean;
    cookieName: string;
    locale: string;
    keywordParamName: string;
    submitCallback: (_q:string, _isListClick:boolean) => void;
}

export default class AutoSuggest{
    option!: Ioption;
    loadedKeyword: string = '';
    dataBaseKeyword: string = '';
    isValueFunctionText: string = '';
    isCookieApply: boolean = false;
    deleteBtnIsShow: boolean = false;
    sto: NodeJS.Timeout | null = null;
    recentData: string[] = [];
    suggestWrap!: HTMLElement;
    inputEl!: HTMLInputElement;
    submitBtn!: HTMLElement;
    deleteBtn!: HTMLElement;
    resultUL!: HTMLElement;
    recentUL!: HTMLElement;
    recentWrap!: HTMLElement;
    recentAllDel!: HTMLElement;
    recentNone!: HTMLElement;
    
    constructor(){}

    public init( _option: Ioption ){
        const initOption = {
            apiUrl: '',
            selector : '#autoSuggest',
            size: 10,
            useDelbtn: false,
            cookieName: 'autosuggest',
            locale: 'ko-KR',
            keywordParamName: 'keyword',
            submitCallback: (_q: string) => console.log( 'query :', _q, '::: option.submitCallback 설정은 필수 입니다' ),
        };

        this.option = {
            ...initOption,
            ..._option
        };
        
        this.suggestWrap = document.querySelector(this.option.selector + " [data-name='suggest_wrap']")!;
        this.inputEl = document.querySelector(this.option.selector + " [data-name='suggest_input']")!;
        this.submitBtn = document.querySelector(this.option.selector + " [data-name='suggest_submit']")!;
        this.deleteBtn = document.querySelector(this.option.selector + " [data-name='suggest_delete']")!;
        this.resultUL = document.querySelector(this.option.selector + " [data-name='suggest_scroll'] ul")!;
        this.deleteBtn.style.display = 'none';

        const htmlEl = document.getElementsByTagName("html")[0];
        const lang = htmlEl.getAttribute('lang') || 'ko';

        if (lang==='ko') {
            this.isCookieApply = true;
        }else{
            let cookieStr = decodeURIComponent(this.getCookie('applyCookie'));
            if (cookieStr) {
                let cookieData: {optCookieListVer: string; typeArr: string[]} = JSON.parse(cookieStr);
                this.isCookieApply = cookieData.typeArr.indexOf('FUNCTIONAL') > -1;
            }else{
                this.isCookieApply = false;
            }
        }

        if (this.isCookieApply) {
            this.recentUL = document.querySelector(this.option.selector + " [data-name='suggest_recent_scroll'] ul")!;
            this.recentWrap = document.querySelector(this.option.selector + " [data-name='suggest_recent']")!;
            this.recentWrap.style.display = 'none';
            this.recentAllDel = document.querySelector(this.option.selector + " [data-name='suggest_recent-del'] button")!;
            this.recentNone = document.querySelector(this.option.selector + " [data-name='suggest_recent-none']")!;

            let cookieData = unescape( this.getCookie(this.option.cookieName) );
            this.recentData = cookieData? JSON.parse( cookieData ): [];
            this.makeRecentList();
        }
        this.addEvents();
    }

    private load(_newKeyword: string){
        this.loadedKeyword = _newKeyword;

        (async () => {
            const res = await axios({
                method: 'get',
                url: this.option.apiUrl+'?'+new URLSearchParams({
                    [this.option.keywordParamName]: this.loadedKeyword, 
                    locale: this.option.locale,
                    size: this.option.size.toString()
                }).toString(),
                withCredentials: true,
            });
            
            this.drawList(res.data);
        })();
    }

    private addEvents(){
        this.inputEl.addEventListener('keydown', (e: KeyboardEvent)=>{
            if ( e.keyCode === 27 ) { // ESC
                this.inputEl.value = this.loadedKeyword;
                this.suggestWrapToggle(false);
                return false;
            }

            if ( e.keyCode === 13 ) { // Enter
                // this.submitGo(0);
                this.submitBtn.focus();
                return false;
            }

            if ( e.keyCode === 9 ) { // Tab
                this.focusChange( !e.shiftKey? 1: -1 );
                return false;
            }

            if ( e.keyCode === 40) { // ↓
                this.focusChange(1);
                return false;
            }

            if ( e.keyCode === 38 ) { // ↑
                this.focusChange(-1);
                return false;
            }
        });

        this.inputEl.addEventListener( 'blur', () => {
            if(this.sto){
                clearTimeout( this.sto );
                this.sto = null;
            }
            setTimeout( () => {
                this.suggestWrapToggle(false);
                if (this.isCookieApply) toggle(this.recentWrap, false);
            } , 150 );
        });

        this.inputEl.addEventListener( 'focus', () => {
            this.isValueFunctionText = '';
            if( !this.sto ) this.realTimeInputCheck();
            toggle(this.suggestWrap, true);
            if( this.resultUL.querySelectorAll('li').length ) {
                this.suggestWrapToggle(true);
            }
        });

        this.submitBtn.addEventListener( 'click', () => this.submitGo(0) );
        
        if (this.isCookieApply){
            this.recentAllDel.addEventListener( 'click', () => {
                this.recentData = [];
                this.setCookie(this.option.cookieName, JSON.stringify(this.recentData));
                this.makeRecentList();
                this.inputEl.value = '';
                this.inputEl.focus();
            });
        }

        this.deleteBtn.addEventListener( 'click', () => {
            this.loadedKeyword = '';
            this.inputEl.value = '';
            this.inputEl.focus();
            this.submitGo(1);
        });

        const resultLis = this.resultUL.querySelectorAll('li');
        resultLis.forEach( it=>{
            it.addEventListener( 'mouseover', (e: MouseEvent) => {
                this.resultUL.querySelectorAll('li').forEach( it => removeClass(it, 'focus'));
                addClass(<HTMLElement>e.currentTarget, 'focus');
            });
        });
    }

    private realTimeInputCheck(){
        if(this.sto){
            clearTimeout( this.sto );
            this.sto = null;
        }

        const inputTxt = this.inputEl.value.trim();

        // 문자열이 있나?
        if( inputTxt ){
            // 바로 앞에서 api 호출한 문자열 인가?
            // 화살표 이동을 통해 입력된 문자열 인가?
            if( this.loadedKeyword !== inputTxt && this.dataBaseKeyword !== inputTxt && this.isValueFunctionText !== inputTxt ){
                this.load( inputTxt );
                this.isValueFunctionText = '';
            }
        } else {
            if (this.isCookieApply) toggle(this.recentWrap, true);
            
            if(this.loadedKeyword != '') {
                setTimeout(()=>{
                    if( this.inputEl.value.trim() ) return;
                    this.loadedKeyword = '';
                }, 10);
            }
            if(this.resultUL.innerHTML != '') {
                setTimeout(()=>{
                    this.resultUL.innerHTML = '';
                    this.suggestWrapToggle(false);
                }, 10);
            }
        }

        this.deleteBtnToggle(inputTxt);
        this.sto = setTimeout(()=>this.realTimeInputCheck(), 10);
    }

    private deleteBtnToggle(inputTxt = ''){
        if(!this.option.useDelbtn) return false;

        if(inputTxt){
            if(!this.deleteBtnIsShow){
                this.deleteBtn.style.display = 'block';
                this.deleteBtnIsShow = true;
            }
        }else{
            if(this.deleteBtnIsShow){
                this.deleteBtn.style.display = 'none';
                this.deleteBtnIsShow = false;
            }
        }
    }

    private drawList(_data: string[]){
        const stringValue = window.location.pathname;
        const checkString = 'notisetting';
        // 인풋에 문자열 없으면 데이터가 들어와도 보여주지 않는다.
        if(!this.inputEl.value.trim()) return;
        
        if (this.isCookieApply) toggle(this.recentWrap, false);

        this.suggestWrapToggle(_data.length>0);
        this.listRemoveEvent();

        let list = '';
        if(_data.length){            
            let key = this.loadedKeyword.replace('(', '\\(').replace(')', '\\)');
            let reg = new RegExp(key, 'i');
            list = _data.map( (item, idx) => {
                const regStr = reg.exec(item);
                if (!regStr) return '';
                const str = item.replace(regStr[0], `<mark>${regStr[0]}</mark>`).replace(/ /gi, '&nbsp;');
                return `<li data-idx="${idx}" data-keyword="${item}" data-areas="${stringValue.indexOf(checkString) == -1 ? '시세_검색_자동완성리스트_클릭' : '알림관리_추가_자동완성리스트_클릭'}" data-contents="${item}">${str}</li>`; 
            } ).join('');
        }
        this.resultUL.innerHTML = list;
        this.listAddEvent();
    }

    private listRemoveEvent(){
        document.querySelectorAll<HTMLElement>( this.option.selector + " [data-name='suggest_scroll'] ul li" ).forEach(it=>{
            it.removeEventListener('click', (e: MouseEvent) => {
                const ele = e.currentTarget as HTMLElement;
                this.inputEl.value =  ele.dataset.keyword as string;
                this.submitGo(3);
            });
        });
    }

    private listAddEvent(){
        document.querySelectorAll<HTMLElement>( this.option.selector + " [data-name='suggest_scroll'] ul li" ).forEach(it=>{
            it.addEventListener('click', (e: MouseEvent) => {
                const ele = e.currentTarget as HTMLElement;
                this.inputEl.value =  ele.dataset.keyword as string;
                this.submitGo(3);
            });
        });
    }

    private focusChange( _direction = 1 ){
        let newFocusEl: HTMLElement | null = null;
        let oldFocusEl: HTMLElement | null = this.resultUL.querySelector('.focus');

        if(_direction === 1){
            newFocusEl = ( oldFocusEl )? <HTMLElement>oldFocusEl.nextElementSibling: this.resultUL.querySelector('li:first-child');
        }
        if(_direction === -1){
            newFocusEl = ( oldFocusEl )? <HTMLElement>oldFocusEl.previousElementSibling: this.resultUL.querySelector('li:last-child');
        }

        this.resultUL.querySelectorAll('li').forEach(it=>removeClass(it, 'focus'));

        this.suggestWrapToggle(newFocusEl !== null);

        if( newFocusEl !== null ){
            addClass(newFocusEl, 'focus');
            this.dataBaseKeyword = newFocusEl.dataset.keyword as string;
            this.inputEl.value = this.dataBaseKeyword;
        }
    }

    private submitGo(_num: number) {
        let isListClick = (_num !== 0 && _num!== 1 && _num!== 4);
        if (_num===0) {
            document.querySelectorAll<HTMLElement>( this.option.selector + " [data-name='suggest_scroll'] ul li" ).forEach(it=>{
                if (hasClass( it, 'focus' )) {
                    isListClick = true;
                }
            });
        }

        this.suggestWrapToggle(false);

        const keyword = this.inputEl.value.trim();

        if (typeof this.option.submitCallback === 'function') {
            if (keyword !== '') {
                this.setRecentList( keyword );
            }
            this.option.submitCallback( keyword, isListClick );
        }
    }

    private suggestWrapToggle(_isShow=true){
        toggle(document.querySelector(this.option.selector + " [data-name='suggest_list']"), _isShow);
        if(!_isShow) this.resultUL.querySelectorAll('li').forEach(it=>removeClass(it, 'focus'));
    }

    private setRecentList(_keyword: string){
        if (!this.isCookieApply) return false;
        if( this.recentData.indexOf(_keyword) === -1 ){
            this.recentData.unshift(_keyword);
            this.recentData.splice(5);
            this.setCookie(this.option.cookieName, JSON.stringify(this.recentData));
            this.makeRecentList();
        }
    }
    
    private makeRecentList(){        
        const stringValue = window.location.pathname;
        const checkString = 'notisetting';
        if (!this.isCookieApply) return false;
        let list = this.recentData.map( (it: string) => `<li data-keyword="${it}" data-areas="${stringValue.indexOf(checkString) == -1 ? '시세_검색_최근검색어리스트_클릭' : '알림관리_추가_최근검색어리스트_클릭'}" data-contents="${it}" >${escapeTag(it)}<input type="button" data-key="${it}" value="X" title="검색어 삭제"></li>` ).join('');
        toggle(this.recentNone, !this.recentData.length);
        toggle(this.recentAllDel, this.recentData.length>0);
        this.recentUL.innerHTML = list;
        this.recentListAddEvent();
    }

    private recentListAddEvent(){
        if (!this.isCookieApply) return false;
        document.querySelectorAll<HTMLElement>( this.option.selector + " [data-name='suggest_recent_scroll'] ul li" ).forEach( it =>{
            it.addEventListener('click', (e: MouseEvent) => {
                const eleT = e.target as HTMLInputElement;
                const eleCT = e.currentTarget as HTMLElement;
                if(eleT.value === "X") return;
                this.inputEl.value = eleCT.dataset.keyword as string;
                this.submitGo(4);
                this.deleteBtnToggle(this.inputEl.value);
            });
        });

        this.recentUL.querySelectorAll<HTMLElement>('li input').forEach((it: HTMLElement)=>{
            it.addEventListener( 'click', (e: MouseEvent) => {
                const ele = <HTMLElement>e.currentTarget;
                const key = <string>ele.dataset.key;
                const idx = this.recentData.indexOf( key );

                this.recentData.splice(idx,1);
                this.setCookie(this.option.cookieName, JSON.stringify(this.recentData));
                this.makeRecentList();
                this.inputEl.value = '';
                this.inputEl.focus();
            });
        });
    }

    private setCookie(name = '', value = '', expiredays = 365, domain = 'plaync.com') {
        let todayDate = new Date();
        todayDate.setDate(todayDate.getDate() + expiredays);
        document.cookie = `${name}=${escape(value)}; path=/; domain=${domain};expires=${todayDate.toUTCString()};SameSite=Lax;`;
    }
    
    private getCookie(name = '') {
        let cookies = document.cookie;
        if (cookies.indexOf(name) == -1) return '';
        let cookie = cookies.substr(cookies.indexOf(name));
        cookie = cookie.split(';')[0];
        cookie = cookie.substr(cookie.indexOf('=') + 1);
        return cookie;
    }
    
    // public ---------------------------------------------------------------------
    public value(_txt: string){
        this.isValueFunctionText = _txt;
        this.inputEl.value = _txt;
    }

    public getValue(){
        return this.inputEl.value.trim();
    }
}